// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvoiceReplenishmentMetricsItemDto } from './IInvoiceReplenishmentMetricsItemDto';
import {
    IInvoiceReplenishmentMetricsItemDtoFromJSON,
    IInvoiceReplenishmentMetricsItemDtoFromJSONTyped,
    IInvoiceReplenishmentMetricsItemDtoToJSON,
    IInvoiceReplenishmentMetricsItemDtoToJSONTyped,
} from './IInvoiceReplenishmentMetricsItemDto';

/**
 * 
 * @export
 * @interface IInvoiceReplenishmentMetricsResponseDto
 */
export interface IInvoiceReplenishmentMetricsResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceReplenishmentMetricsResponseDto
     */
    previous_invoice_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceReplenishmentMetricsResponseDto
     */
    previous_invoice_amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IInvoiceReplenishmentMetricsResponseDto
     */
    current_invoice_date?: Date;
    /**
     * 
     * @type {number}
     * @memberof IInvoiceReplenishmentMetricsResponseDto
     */
    current_invoice_amount?: number;
    /**
     * 
     * @type {Array<IInvoiceReplenishmentMetricsItemDto>}
     * @memberof IInvoiceReplenishmentMetricsResponseDto
     */
    invoices?: Array<IInvoiceReplenishmentMetricsItemDto>;
}

/**
 * Check if a given object implements the IInvoiceReplenishmentMetricsResponseDto interface.
 */
export function instanceOfIInvoiceReplenishmentMetricsResponseDto(value: object): value is IInvoiceReplenishmentMetricsResponseDto {
    return true;
}

export function IInvoiceReplenishmentMetricsResponseDtoFromJSON(json: any): IInvoiceReplenishmentMetricsResponseDto {
    return IInvoiceReplenishmentMetricsResponseDtoFromJSONTyped(json, false);
}

export function IInvoiceReplenishmentMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvoiceReplenishmentMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'previous_invoice_date': json['previous_invoice_date'] == null ? undefined : (new Date(json['previous_invoice_date'])),
        'previous_invoice_amount': json['previous_invoice_amount'] == null ? undefined : json['previous_invoice_amount'],
        'current_invoice_date': json['current_invoice_date'] == null ? undefined : (new Date(json['current_invoice_date'])),
        'current_invoice_amount': json['current_invoice_amount'] == null ? undefined : json['current_invoice_amount'],
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(IInvoiceReplenishmentMetricsItemDtoFromJSON)),
    };
}

export function IInvoiceReplenishmentMetricsResponseDtoToJSON(json: any): IInvoiceReplenishmentMetricsResponseDto {
    return IInvoiceReplenishmentMetricsResponseDtoToJSONTyped(json, false);
}

export function IInvoiceReplenishmentMetricsResponseDtoToJSONTyped(value?: IInvoiceReplenishmentMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'previous_invoice_date': value['previous_invoice_date'] == null ? undefined : ((value['previous_invoice_date']).toISOString()),
        'previous_invoice_amount': value['previous_invoice_amount'],
        'current_invoice_date': value['current_invoice_date'] == null ? undefined : ((value['current_invoice_date']).toISOString()),
        'current_invoice_amount': value['current_invoice_amount'],
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(IInvoiceReplenishmentMetricsItemDtoToJSON)),
    };
}

